import InputForm from '../ShowFieldGroupSPEI/inputForm';
import { useState } from 'react';

function show(country,infoBankProps,order_number) {
    const infoBank = sessionStorage.getItem("bank_info_sepa") !== null ? JSON.parse(sessionStorage.getItem("bank_info_sepa")) : []
    switch (country) {
        default:
            return (
                <div className="content content-ted">
                    <div className="col-content">
                        <InputForm
                            for={"nomebanco"}
                            label={"NOME DO BANCO"}
                            data_lang_label={"nome_banck"}
                            value={infoBank[0]?.bank_name}
                            infoBank={infoBank}
                        />
                        <InputForm
                            for={"favorecido"}
                            label={"FAVORECIDO"}
                            data_lang_label={"beneficiary"}
                            value={infoBank[0]?.accoauntable}
                            infoBank={infoBank}
                        />
                        <InputForm
                            for={"IBAN"}
                            label={"IBAN"}
                            data_lang_label={"IBAN"}
                            value={infoBank[0]?.account}
                            infoBank={infoBank}
                        />
                        <InputForm
                            for={"BIC"}
                            label={"BIC"}
                            data_lang_label={"BIC"}
                            value={infoBank[0]?.agency}
                            infoBank={infoBank}
                        />
                        <InputForm
                            for={"ref_code"}
                            label={"ref_code"}
                            data_lang_label={"ref_code"}
                            value={order_number}
                            infoBank={infoBank}
                        />
                    </div>

                </div>
            )
    }
}
//  beneficiary, IBAN, BIC, bank name and a reference.
export default function ShowFieldGroupSEPA(props) {
    return show(props.country, props.infoBank,props.order_number);
}